
const deleteSection = async (inSectionId) => {
    let sectionThree = window.threeViewer.scene.children.find(s => s.userData.id === inSectionId);
    if (sectionThree) {
		delete window.sections[inSectionId];
		window.threeViewer.scene.remove(sectionThree)
        sectionThree.material.dispose()
        sectionThree.geometry.dispose()
        sectionThree.material?.map?.dispose()
    }
}

export default deleteSection;